import { createApi } from "@reduxjs/toolkit/query/react";
import { baseQueryWithReauth } from "../api.config";

export const buyerPreferencesApi = createApi({
  reducerPath: "buyerPreferencesApi",
  baseQuery: baseQueryWithReauth,
  tagTypes: ["BuyerPreferences"],
  endpoints: (builder) => ({
    // Get all buyer preferences
    getAllBuyerPreferences: builder.query({
      query: (params) => ({
        url: "/buyer-preferences",
        params,
      }),
      providesTags: ["BuyerPreferences"],
    }),

    // Get single buyer preferences
    getBuyerPreferencesById: builder.query({
      query: (id) => `/buyer-preferences/${id}`,
      providesTags: (result, error, id) => [{ type: "BuyerPreferences", id }],
    }),

    // Create buyer preferences
    createBuyerPreferences: builder.mutation({
      query: (data) => ({
        url: "/buyer-preferences",
        method: "POST",
        body: data,
      }),
      invalidatesTags: ["BuyerPreferences"],
    }),

    // Update buyer preferences
    updateBuyerPreferences: builder.mutation({
      query: ({ id, ...data }) => ({
        url: `/buyer-preferences/${id}`,
        method: "PUT",
        body: data,
      }),
      invalidatesTags: (result, error, { id }) => [
        { type: "BuyerPreferences", id },
        "BuyerPreferences",
      ],
    }),

    // Add property shown
    addPropertyShown: builder.mutation({
      query: ({ id, ...data }) => ({
        url: `/buyer-preferences/${id}/showing`,
        method: "POST",
        body: data,
      }),
      invalidatesTags: (result, error, { id }) => [
        { type: "BuyerPreferences", id },
        "BuyerPreferences",
      ],
    }),

    // Update showing feedback
    updateShowingFeedback: builder.mutation({
      query: ({ id, showingId, feedback, rating }) => ({
        url: `/buyer-preferences/${id}/showing`,
        method: "PATCH",
        body: { showingId, feedback, rating },
      }),
      invalidatesTags: (result, error, { id }) => [
        { type: "BuyerPreferences", id },
        "BuyerPreferences",
      ],
    }),

    // Delete buyer preferences
    deleteBuyerPreferences: builder.mutation({
      query: (id) => ({
        url: `/buyer-preferences/${id}`,
        method: "DELETE",
      }),
      invalidatesTags: ["BuyerPreferences"],
    }),

    // Get matching properties
    getMatchingProperties: builder.query({
      query: (id) => `/buyer-preferences/${id}/matches`,
    }),
  }),
});

export const {
  useGetAllBuyerPreferencesQuery,
  useGetBuyerPreferencesByIdQuery,
  useCreateBuyerPreferencesMutation,
  useUpdateBuyerPreferencesMutation,
  useAddPropertyShownMutation,
  useUpdateShowingFeedbackMutation,
  useDeleteBuyerPreferencesMutation,
  useGetMatchingPropertiesQuery,
} = buyerPreferencesApi;
